import React from "react";
import PropTypes from "prop-types";
import CommonModal from "./CommonModal";
import {
  alertActions,
  buttonName,
  passwordConfirmModal
} from "../../locales/en";
import Modalstyle from "./modal.module.scss";

const PasswordConfModal = ({
  isOpen,
  onClose,
  onSubmit,
  password,
  setPassword,
  title,
  content,
  listSub,
  errorMessage
}) => {
  return (
    <CommonModal
      isOpen={isOpen}
      toggle={onClose}
      title={title}
      modalClassName="modal-dialog-centered"
      bodyClassName={Modalstyle.passwordModalWrap}
      footerButtons={[
        {
          label: buttonName?.close,
          className: "btn btn-secondary",
          onClick: onClose
        },
        {
          label: alertActions?.Confirm,
          className: "btn btn-primary",
          onClick: onSubmit
        }
      ]}
    >
      <div className="row">
        <div className="mb-3">
          <div
            className={`${Modalstyle.modalInputwrap} ${Modalstyle.passwordModalWrap}`}
          >
            {listSub && (
              <ul className="mb-3 ps-3">
                <li>{listSub}</li>
              </ul>
            )}

            {content && (
              <label htmlFor="passwordInput" className="form-label">
                {content}
              </label>
            )}

            <div className={Modalstyle.formInput}>
              <input
                type="text"
                name="fake-username"
                autoComplete="username"
                style={{ display: "none" }}
                tabIndex={-1}
              />
              <input
                id="passwordInput"
                type="password"
                name={`confirm-password-${Date.now()}`}
                autoComplete="new-password"
                data-lpignore="true"
                data-form-type="other"
                spellCheck={false}
                value={password}
                className="mt-2"
                onChange={(e) => setPassword(e.target.value)}
                placeholder={passwordConfirmModal?.placeholder}
              />
              {errorMessage && (
                <small className="text-danger mt-1 d-block">
                  {errorMessage}
                </small>
              )}
            </div>
          </div>
        </div>
      </div>
    </CommonModal>
  );
};

PasswordConfModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  password: PropTypes.string.isRequired,
  setPassword: PropTypes.func.isRequired,
  title: PropTypes.string,
  content: PropTypes.string,
  listSub: PropTypes.string,
  errorMessage: PropTypes.string
};

export default PasswordConfModal;
